// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Info } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconInfo(props: any) {
    return <IconBase icon={Info} {...props} />
  }

  export default IconInfo
  